// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header.waggle-navigation {
  height: 60px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  background-color: white;
  justify-content: space-between;
  align-items: center;
  font-family: "Proxima Nova", sans-serif;
}
header.waggle-navigation .logo-container {
  max-width: 140px;
  width: 100%;
  display: flex;
  align-items: center;
}
header.waggle-navigation .nav-items {
  align-self: center;
}
header.waggle-navigation .nav-items > ul {
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 40px;
}
header.waggle-navigation .nav-items > ul > li {
  border-radius: 12px;
  transition: 0.2s ease-in-out all;
  display: flex;
  position: relative;
  cursor: pointer;
  height: 40px;
  width: 40px;
  align-items: center;
  justify-content: center;
  background-color: white;
}
header.waggle-navigation .nav-items > ul > li:hover {
  opacity: 0.75;
  background-color: var(--secondary-color-4);
}
header.waggle-navigation .nav-items > ul > li:hover::before {
  content: attr(data-name);
  font-size: 12px;
  text-align: center;
  position: absolute;
  top: 45px;
  left: 0;
  right: 0;
  background-color: var(--secondary-color-2);
  color: #fff;
  padding: 8px 10px;
  border-radius: 10px;
  display: block;
  width: 100px;
  margin-left: -30px;
}
header.waggle-navigation .nav-items > ul > li:last-child {
  margin-right: 0;
}
header.waggle-navigation .nav-items > ul > li.active {
  background-color: var(--primary-color-1);
}
header.waggle-navigation .nav-items > ul > li.active:hover {
  opacity: 1;
  background-color: #FEF4D2;
}
header.waggle-navigation .nav-items > ul > li.messages {
  position: relative;
}
header.waggle-navigation .nav-items > ul > li.messages > p.notif {
  margin: 0;
  height: 12px;
  width: 12px;
  border-radius: 3px;
  top: 5px;
  right: 5px;
  display: flex;
  padding-top: 1px;
  align-items: center;
  justify-content: center;
  position: absolute;
  background-color: rgb(250, 69, 69);
  font-family: "Proxima Nova", sans-serif;
  font-size: 8px;
  font-weight: 700;
  color: white;
}

@media (min-width: 768px) and (max-width: 1024px), (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  header.waggle-navigation {
    padding: 0 40px;
  }
}
@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  header.waggle-navigation {
    padding: 0 24px;
  }
  header.waggle-navigation .logo-container > div {
    display: flex;
    align-items: center;
  }
  header.waggle-navigation .showing-bee-logo > img {
    height: 24px !important;
    width: 24px !important;
  }
  header.waggle-navigation .nav-items {
    align-self: center;
  }
  header.waggle-navigation .nav-items > ul {
    column-gap: 10px;
  }
  header.waggle-navigation .nav-items > ul > li {
    border-radius: 8px;
    padding: 6px;
    height: 25px;
    width: 25px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/HeaderNavigation/headerNavigation.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,YAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,mBAAA;EACA,uCAAA;AADJ;AAEI;EACI,gBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;AAAR;AAEI;EACI,kBAAA;AAAR;AACQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AACZ;AAAY;EACI,mBAAA;EACA,gCAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;AAEhB;AADgB;EACI,aAAA;EACA,0CAAA;AAGpB;AAFoB;EACI,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,0CAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;AAIxB;AADgB;EACK,eAAA;AAGrB;AADgB;EACI,wCAAA;AAGpB;AAFoB;EACI,UAAA;EACA,yBAAA;AAIxB;AADgB;EACI,kBAAA;AAGpB;AAFoB;EACI,SAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kCAAA;EACA,uCAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;AAIxB;;AC7EY;EDkFR;IACI,eAAA;EADN;AACF;AC1FY;EDgGR;IACI,eAAA;EAHN;EAKU;IACI,aAAA;IACA,mBAAA;EAHd;EAMM;IACI,uBAAA;IACA,sBAAA;EAJV;EAMM;IACI,kBAAA;EAJV;EAKU;IACI,gBAAA;EAHd;EAIc;IACI,kBAAA;IACA,YAAA;IACA,YAAA;IACA,WAAA;EAFlB;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\r\n\r\nheader.waggle-navigation {\r\n    height: 60px;\r\n    width: 100%;\r\n    margin: 0 auto;\r\n    display: flex;\r\n    background-color: white;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    font-family: 'Proxima Nova', sans-serif;\r\n    .logo-container {\r\n        max-width: 140px;\r\n        width: 100%;\r\n        display: flex;\r\n        align-items: center\r\n    }\r\n    .nav-items {\r\n        align-self: center;\r\n        > ul {\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n            column-gap: 40px;\r\n            > li {\r\n                border-radius: 12px;\r\n                transition: .2s ease-in-out all;\r\n                display: flex;\r\n                position: relative;\r\n                cursor: pointer;\r\n                height: 40px;\r\n                width: 40px;\r\n                align-items: center;\r\n                justify-content: center;\r\n                background-color: white;\r\n                &:hover {\r\n                    opacity: .75;\r\n                    background-color: var(--secondary-color-4);\r\n                    &::before {\r\n                        content: attr(data-name);\r\n                        font-size: 12px;\r\n                        text-align: center;\r\n                        position: absolute;\r\n                        top: 45px;\r\n                        left: 0;\r\n                        right: 0;\r\n                        background-color: var(--secondary-color-2);\r\n                        color: #fff;  \r\n                        padding: 8px 10px;\r\n                        border-radius: 10px;\r\n                        display: block;\r\n                        width: 100px;\r\n                        margin-left: -30px;\r\n                    }\r\n                }\r\n                &:last-child{\r\n                     margin-right: 0;\r\n                }\r\n                &.active {\r\n                    background-color: var(--primary-color-1);\r\n                    &:hover {\r\n                        opacity: 1;\r\n                        background-color: #FEF4D2;\r\n                    }\r\n                }\r\n                &.messages {\r\n                    position: relative;\r\n                    > p.notif {\r\n                        margin: 0;\r\n                        height: 12px;\r\n                        width: 12px;\r\n                        border-radius: 3px;\r\n                        top: 5px;\r\n                        right: 5px;\r\n                        display: flex;\r\n                        padding-top: 1px;\r\n                        align-items: center;\r\n                        justify-content: center;\r\n                        position: absolute;\r\n                        background-color: rgb(250, 69, 69);\r\n                        font-family: 'Proxima Nova', sans-serif;  \r\n                        font-size: 8px;\r\n                        font-weight: 700;\r\n                        color: white;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@include media(tablet) {\r\n    header.waggle-navigation {\r\n        padding: 0 40px;\r\n    }\r\n}\r\n\r\n\r\n@include media(mobile) {\r\n    header.waggle-navigation {\r\n        padding: 0 24px;\r\n        .logo-container {\r\n            > div {\r\n                display: flex;\r\n                align-items: center;\r\n            }\r\n        }\r\n        .showing-bee-logo > img {\r\n            height: 24px !important;\r\n            width: 24px !important;\r\n        }\r\n        .nav-items {\r\n            align-self: center;\r\n            > ul {\r\n                column-gap: 10px;\r\n                > li {\r\n                    border-radius: 8px;\r\n                    padding: 6px;\r\n                    height: 25px;\r\n                    width: 25px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
